import { NgModule } from '@angular/core';
import { SearchFilterPipe } from './search-filter.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { AbbreviatePipe } from './abbreviate-num.pipe';
import { DateFormatPipe } from './date-format.pipe';

@NgModule({
  imports: [
  ],
  declarations: [
    SearchFilterPipe,
    AbbreviatePipe,
    SafeUrlPipe,
    DateFormatPipe,
  ],
  exports: [
    SearchFilterPipe,
    AbbreviatePipe,
    SafeUrlPipe,
    DateFormatPipe,
  ]
})

export class CustomPipeModule { }
